export interface TemplateStructure {
  mostrarAntecedentes: boolean;
  mostrarCursos: boolean;
  mostrarParticipantes: boolean;
  mostrarAntecedentesEmpresa: boolean;
  mostrarAntecedenteNombre: boolean;
  mostrarAntecedenteCedula: boolean;
  mostrarAntecedenteEmail: boolean;
  mostrarAntecedenteComuna: boolean;
  mostrarAntecedentePais: boolean;
  mostrarAntecedenteTelefono: boolean;
  mostrarAntecedenteCelular: boolean;
  mostrarCursoNro: boolean;
  mostrarCursoNombre: boolean;
  mostrarCursoPersonas: boolean;
  mostrarParticipanteNombre: boolean;
  mostrarParticipanteEmail: boolean;
  mostrarParticipanteCi: boolean;
  mostrarParticipanteRol: boolean;
  mostrarParticipanteCurso: boolean;
  mostrarEmpresaRazon: boolean;
  mostrarEmpresaGiro: boolean;
  mostrarEmpresaRut: boolean;
  mostrarEmpresaEncargado: boolean;
  mostrarEmpresaEmail: boolean;
  mostrarEmpresaComuna: boolean;
  mostrarEmpresaRegion: boolean;
  mostrarEmpresaTelefono: boolean;
  mostrarEmpresaCelular: boolean;
}

export interface TemplateStructureResponse {
  source: string;
  templateStructure: TemplateStructure;
}

export const DEFAULT_TEMPLATE_STRUCTURE: TemplateStructure = {
  mostrarAntecedentes: true,
  mostrarCursos: true,
  mostrarParticipantes: true,
  mostrarAntecedentesEmpresa: true,
  mostrarAntecedenteNombre: true,
  mostrarAntecedenteCedula: true,
  mostrarAntecedenteEmail: true,
  mostrarAntecedenteComuna: true,
  mostrarAntecedentePais: true,
  mostrarAntecedenteTelefono: true,
  mostrarAntecedenteCelular: true,
  mostrarCursoNro: true,
  mostrarCursoNombre: true,
  mostrarCursoPersonas: true,
  mostrarParticipanteNombre: true,
  mostrarParticipanteEmail: true,
  mostrarParticipanteCi: true,
  mostrarParticipanteRol: true,
  mostrarParticipanteCurso: true,
  mostrarEmpresaRazon: true,
  mostrarEmpresaGiro: true,
  mostrarEmpresaRut: true,
  mostrarEmpresaEncargado: true,
  mostrarEmpresaEmail: true,
  mostrarEmpresaComuna: true,
  mostrarEmpresaRegion: true,
  mostrarEmpresaTelefono: true,
  mostrarEmpresaCelular: true
};
